import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input} from '@angular/core';
import {AppService} from '../../commons/app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';


import {MainService} from '../main.service';
import {forkJoin, Observable, of as observableOf, Subscription} from 'rxjs';
import {MainComponent} from '../main.component';

import {APIDialog} from '../../commons/dialogs/explorer.dialogs'
import {VasatSearchQuery} from 'vasat'
import {Annotation, FourdCesiumHelper, FourDService, Project, Transform, TransformType,Job,JobBatch,Dataset,Folder} from '4d-mapper';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';

const Cesium = (<any>window).Cesium;

@Component({
  selector: 'job-details',
  templateUrl: './job.component.html'

})
export class JobComponent extends AppBaseComponent implements OnInit, OnDestroy {

  @Input() job:Job

  batches:VasatSearchQuery<JobBatch>

  initalTransform:JobBatch


  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private ar: ActivatedRoute, 
    private t: TranslateService, private mainComponent: MainComponent, private mainService: MainService, private trans: TranslateService, applicationEvents:XsApplicationEventsService) {
    super(service, r, sn, d, applicationEvents);
  }

  ngOnChanges(changes) {
    this.refresh()
  }
  refresh(){
    this.job.inputDatasets.useCache(true).queryObservable().subscribe()
    this.job.inputFolders.useCache(true).queryObservable().subscribe()
    setTimeout(() => this.job.jobType.subTransforms.useCache(true).queryObservable().subscribe(),1000)
    this.batches = this.job.batches()

    this.batches.useCache(true).sortBy('dateMade',true).queryObservable().subscribe(res =>
      this.initalTransform = res.items.find(cur => cur.transformType == this.job.jobType.baseTransform)
    )
  }

  addDataset(){
   this.openDialogWithMode('file_all',"PROJECT.DIALOG.ADD_FOLDER_TITLE","PROJECT.DIALOG.ADD_FOLDER_TEXT").subscribe(dest => {

     if(!dest) return
     var itms:Dataset[] = dest

     forkJoin(
       itms.map(d => this.job.inputDatasets.addObserveable(d))
     ).subscribe(s => {
         this.openSnackBarSuccess('GENERIC.SAVED',null)
         this.job.inputDatasets.items.subscribe()
       },
       e => this.openSnackBarError(e.message,null)
      )

    },
      e => this.openSnackBarError(e.message,null)
    )

  }

  addFolder(){
     this.openDialogWithMode('folder',"PROJECT.DIALOG.ADD_FOLDER_TITLE","PROJECT.DIALOG.ADD_FOLDER_TEXT")
     .subscribe(dest => {
        if(!dest) return

        this.job.inputFolders.addObserveable(dest).subscribe(s => {
            this.openSnackBarSuccess(s + ' PROJECT.DIALOG.ITEMS_ADDED')
            this.job.inputFolders.items.subscribe()
          },
          e => this.openSnackBarError(e)
        )

      },
        e => this.openSnackBarError(e.message,null)
      )

  }

  runXForm(tt:TransformType){

      var onReady: Observable<any> = null

      onReady = tt['needsInput'] ? this.showInputDialogForT({}, tt) : observableOf({model: {}})

      onReady.subscribe(params => {

        if (!params) return

        this.job.startTransform(tt,params.model).subscribe(s =>
            this.openSnackBarInfo(tt.name + ' PROJECT.DIALOG.STARTED')
        ,
          e => this.openSnackBarError('GENERIC.ERROR ' + e.message)
        )

      })

  }

  showInputDialogForT(model: any, tt: TransformType) {
    let dialogRef = this.dialog.open(APIDialog, {

      // height: '80%',
      data: {model:model, apis: [tt], title: 'TYPES.' + tt.uid}
    });

    return dialogRef.afterClosed()
  }

}

